import React from "react";
import '../styles/common.scss';

const MemberAvartar = () => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.4">
      </g>
    </svg>
  );
};
export default MemberAvartar;